import { render, staticRenderFns } from "./Feasts.vue?vue&type=template&id=281e0938&scoped=true&"
import script from "./Feasts.vue?vue&type=script&lang=js&"
export * from "./Feasts.vue?vue&type=script&lang=js&"
import style0 from "./Feasts.vue?vue&type=style&index=0&id=281e0938&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "281e0938",
  null
  
)

export default component.exports